import { createContext } from 'react';

export type RejectSetupCtx = {
  showRejectSetupConfirmationAlert: boolean;
};

const RejectSetupContext = createContext<RejectSetupCtx>({
  showRejectSetupConfirmationAlert: false,
});

export default RejectSetupContext;
